import BudgetSection from "../Common/BudgetSection";
import { COLORS } from "../../../lib/appColors";

export default function Expense() {
  return (
    <BudgetSection
      itemType="expense"
      accentColor={COLORS.expense}
      addLabel="ADD EXPENSE"
      addPath="/budget/expenses/new"
      emptyMessage='No expense records yet. Click "Add Expense" to create your first entry.'
    />
  );
}
